module.exports = __webpack_public_path__ + "static/media/college-graduation.7d9c43fb.svg";